/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiUserTasksGetLastSelectedIdParameter,
  ApiUserTasksGetPageParameter,
  GetApprovedMakeupRosterEntryResponse,
  GetMakeupResponse,
  MakeupCancellationRequest,
  MakeupChangeRequest,
  MakeupRequest,
  MakeupScrollFilterRequest,
  PaginatedResultOfGetMakeupResponse,
  RejectMakeupChangeRequest,
  RejectMakeupRequest,
  Result,
  ResultOfCreateLocationResponse,
  StaffReviewConflict,
} from '../models/index';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterToJSON,
    GetApprovedMakeupRosterEntryResponseFromJSON,
    GetApprovedMakeupRosterEntryResponseToJSON,
    GetMakeupResponseFromJSON,
    GetMakeupResponseToJSON,
    MakeupCancellationRequestFromJSON,
    MakeupCancellationRequestToJSON,
    MakeupChangeRequestFromJSON,
    MakeupChangeRequestToJSON,
    MakeupRequestFromJSON,
    MakeupRequestToJSON,
    MakeupScrollFilterRequestFromJSON,
    MakeupScrollFilterRequestToJSON,
    PaginatedResultOfGetMakeupResponseFromJSON,
    PaginatedResultOfGetMakeupResponseToJSON,
    RejectMakeupChangeRequestFromJSON,
    RejectMakeupChangeRequestToJSON,
    RejectMakeupRequestFromJSON,
    RejectMakeupRequestToJSON,
    ResultFromJSON,
    ResultToJSON,
    ResultOfCreateLocationResponseFromJSON,
    ResultOfCreateLocationResponseToJSON,
    StaffReviewConflictFromJSON,
    StaffReviewConflictToJSON,
} from '../models/index';

export interface ApiMakeupSessionsApprovedForClassClassIdGetRequest {
    classId: number;
    date?: Date;
    xTenantID?: number;
}

export interface ApiMakeupSessionsIdAcceptChangePutRequest {
    id: string;
    xTenantID?: number;
}

export interface ApiMakeupSessionsIdApprovePutRequest {
    id: string;
    xTenantID?: number;
}

export interface ApiMakeupSessionsIdCancelPutRequest {
    id: string;
    makeupCancellationRequest: MakeupCancellationRequest;
    xTenantID?: number;
}

export interface ApiMakeupSessionsIdDeleteRequest {
    id: string;
    xTenantID?: number;
}

export interface ApiMakeupSessionsIdGetRequest {
    id: string;
    xTenantID?: number;
}

export interface ApiMakeupSessionsIdRejectChangePutRequest {
    id: string;
    rejectMakeupChangeRequest: RejectMakeupChangeRequest;
    xTenantID?: number;
}

export interface ApiMakeupSessionsIdRejectPutRequest {
    id: string;
    rejectMakeupRequest: RejectMakeupRequest;
    xTenantID?: number;
}

export interface ApiMakeupSessionsIdRequestChangePutRequest {
    id: string;
    makeupChangeRequest: MakeupChangeRequest;
    xTenantID?: number;
}

export interface ApiMakeupSessionsIdReviewPresenceDeleteRequest {
    id: string;
    xTenantID?: number;
}

export interface ApiMakeupSessionsIdReviewPresencePutRequest {
    id: string;
    xTenantID?: number;
}

export interface ApiMakeupSessionsPostRequest {
    makeupRequest: MakeupRequest;
    xTenantID?: number;
}

export interface ApiMakeupSessionsSearchPostRequest {
    makeupScrollFilterRequest: MakeupScrollFilterRequest;
    page?: ApiUserTasksGetPageParameter;
    pageSize?: ApiUserTasksGetPageParameter;
    lastSelectedId?: ApiUserTasksGetLastSelectedIdParameter;
    active?: boolean;
    xTenantID?: number;
}

/**
 * 
 */
export class MakeupSessionsApi extends runtime.BaseAPI {

    /**
     * Returns approved makeup students for a class on a specific session date (teacher roster overlay).
     * Approved makeups for class date
     */
    async apiMakeupSessionsApprovedForClassClassIdGetRaw(requestParameters: ApiMakeupSessionsApprovedForClassClassIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetApprovedMakeupRosterEntryResponse>>> {
        if (requestParameters['classId'] == null) {
            throw new runtime.RequiredError(
                'classId',
                'Required parameter "classId" was null or undefined when calling apiMakeupSessionsApprovedForClassClassIdGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['date'] != null) {
            queryParameters['date'] = (requestParameters['date'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/makeup-sessions/approved-for-class/{classId}`;
        urlPath = urlPath.replace(`{${"classId"}}`, encodeURIComponent(String(requestParameters['classId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetApprovedMakeupRosterEntryResponseFromJSON));
    }

    /**
     * Returns approved makeup students for a class on a specific session date (teacher roster overlay).
     * Approved makeups for class date
     */
    async apiMakeupSessionsApprovedForClassClassIdGet(requestParameters: ApiMakeupSessionsApprovedForClassClassIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetApprovedMakeupRosterEntryResponse>> {
        const response = await this.apiMakeupSessionsApprovedForClassClassIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Parent accepts admin proposal for a makeup session.
     * Accept proposed makeup
     */
    async apiMakeupSessionsIdAcceptChangePutRaw(requestParameters: ApiMakeupSessionsIdAcceptChangePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiMakeupSessionsIdAcceptChangePut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/makeup-sessions/{id}/accept-change`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Parent accepts admin proposal for a makeup session.
     * Accept proposed makeup
     */
    async apiMakeupSessionsIdAcceptChangePut(requestParameters: ApiMakeupSessionsIdAcceptChangePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiMakeupSessionsIdAcceptChangePutRaw(requestParameters, initOverrides);
    }

    /**
     * An admin or staff member approves requested makeup
     * Approve requested makeup
     */
    async apiMakeupSessionsIdApprovePutRaw(requestParameters: ApiMakeupSessionsIdApprovePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiMakeupSessionsIdApprovePut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/makeup-sessions/{id}/approve`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * An admin or staff member approves requested makeup
     * Approve requested makeup
     */
    async apiMakeupSessionsIdApprovePut(requestParameters: ApiMakeupSessionsIdApprovePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiMakeupSessionsIdApprovePutRaw(requestParameters, initOverrides);
    }

    /**
     * An admin or parent cancels a requested makeup session.
     * Cancel requested makeup
     */
    async apiMakeupSessionsIdCancelPutRaw(requestParameters: ApiMakeupSessionsIdCancelPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiMakeupSessionsIdCancelPut().'
            );
        }

        if (requestParameters['makeupCancellationRequest'] == null) {
            throw new runtime.RequiredError(
                'makeupCancellationRequest',
                'Required parameter "makeupCancellationRequest" was null or undefined when calling apiMakeupSessionsIdCancelPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/makeup-sessions/{id}/cancel`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MakeupCancellationRequestToJSON(requestParameters['makeupCancellationRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * An admin or parent cancels a requested makeup session.
     * Cancel requested makeup
     */
    async apiMakeupSessionsIdCancelPut(requestParameters: ApiMakeupSessionsIdCancelPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiMakeupSessionsIdCancelPutRaw(requestParameters, initOverrides);
    }

    /**
     * Parent/Admin deletes a makeup session
     * Delete makeup
     */
    async apiMakeupSessionsIdDeleteRaw(requestParameters: ApiMakeupSessionsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiMakeupSessionsIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/makeup-sessions/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Parent/Admin deletes a makeup session
     * Delete makeup
     */
    async apiMakeupSessionsIdDelete(requestParameters: ApiMakeupSessionsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiMakeupSessionsIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Get makeup session by id
     * Get makeup session
     */
    async apiMakeupSessionsIdGetRaw(requestParameters: ApiMakeupSessionsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMakeupResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiMakeupSessionsIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/makeup-sessions/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMakeupResponseFromJSON(jsonValue));
    }

    /**
     * Get makeup session by id
     * Get makeup session
     */
    async apiMakeupSessionsIdGet(requestParameters: ApiMakeupSessionsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMakeupResponse> {
        const response = await this.apiMakeupSessionsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Parent rejects admin proposal for a makeup session.
     * Reject proposed makeup
     */
    async apiMakeupSessionsIdRejectChangePutRaw(requestParameters: ApiMakeupSessionsIdRejectChangePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiMakeupSessionsIdRejectChangePut().'
            );
        }

        if (requestParameters['rejectMakeupChangeRequest'] == null) {
            throw new runtime.RequiredError(
                'rejectMakeupChangeRequest',
                'Required parameter "rejectMakeupChangeRequest" was null or undefined when calling apiMakeupSessionsIdRejectChangePut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/makeup-sessions/{id}/reject-change`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RejectMakeupChangeRequestToJSON(requestParameters['rejectMakeupChangeRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Parent rejects admin proposal for a makeup session.
     * Reject proposed makeup
     */
    async apiMakeupSessionsIdRejectChangePut(requestParameters: ApiMakeupSessionsIdRejectChangePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiMakeupSessionsIdRejectChangePutRaw(requestParameters, initOverrides);
    }

    /**
     * An admin or staff member rejects a pending makeup request and optionally sends a note to the parent.
     * Reject makeup request
     */
    async apiMakeupSessionsIdRejectPutRaw(requestParameters: ApiMakeupSessionsIdRejectPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiMakeupSessionsIdRejectPut().'
            );
        }

        if (requestParameters['rejectMakeupRequest'] == null) {
            throw new runtime.RequiredError(
                'rejectMakeupRequest',
                'Required parameter "rejectMakeupRequest" was null or undefined when calling apiMakeupSessionsIdRejectPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/makeup-sessions/{id}/reject`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RejectMakeupRequestToJSON(requestParameters['rejectMakeupRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * An admin or staff member rejects a pending makeup request and optionally sends a note to the parent.
     * Reject makeup request
     */
    async apiMakeupSessionsIdRejectPut(requestParameters: ApiMakeupSessionsIdRejectPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiMakeupSessionsIdRejectPutRaw(requestParameters, initOverrides);
    }

    /**
     * An admin or staff member requests a change to a makeup session
     * Request makeup change
     */
    async apiMakeupSessionsIdRequestChangePutRaw(requestParameters: ApiMakeupSessionsIdRequestChangePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiMakeupSessionsIdRequestChangePut().'
            );
        }

        if (requestParameters['makeupChangeRequest'] == null) {
            throw new runtime.RequiredError(
                'makeupChangeRequest',
                'Required parameter "makeupChangeRequest" was null or undefined when calling apiMakeupSessionsIdRequestChangePut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/makeup-sessions/{id}/request-change`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MakeupChangeRequestToJSON(requestParameters['makeupChangeRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * An admin or staff member requests a change to a makeup session
     * Request makeup change
     */
    async apiMakeupSessionsIdRequestChangePut(requestParameters: ApiMakeupSessionsIdRequestChangePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiMakeupSessionsIdRequestChangePutRaw(requestParameters, initOverrides);
    }

    /**
     * Clears review presence for the current user when the makeup review modal closes.
     * Clear makeup review presence
     */
    async apiMakeupSessionsIdReviewPresenceDeleteRaw(requestParameters: ApiMakeupSessionsIdReviewPresenceDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiMakeupSessionsIdReviewPresenceDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/makeup-sessions/{id}/review-presence`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Clears review presence for the current user when the makeup review modal closes.
     * Clear makeup review presence
     */
    async apiMakeupSessionsIdReviewPresenceDelete(requestParameters: ApiMakeupSessionsIdReviewPresenceDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiMakeupSessionsIdReviewPresenceDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * While an admin or staff member has a makeup review modal open, refreshes who is viewing the request.
     * Heartbeat makeup review presence
     */
    async apiMakeupSessionsIdReviewPresencePutRaw(requestParameters: ApiMakeupSessionsIdReviewPresencePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiMakeupSessionsIdReviewPresencePut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/makeup-sessions/{id}/review-presence`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * While an admin or staff member has a makeup review modal open, refreshes who is viewing the request.
     * Heartbeat makeup review presence
     */
    async apiMakeupSessionsIdReviewPresencePut(requestParameters: ApiMakeupSessionsIdReviewPresencePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiMakeupSessionsIdReviewPresencePutRaw(requestParameters, initOverrides);
    }

    /**
     * Request makeup for selected day of abscense
     * Request makeup
     */
    async apiMakeupSessionsPostRaw(requestParameters: ApiMakeupSessionsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfCreateLocationResponse>> {
        if (requestParameters['makeupRequest'] == null) {
            throw new runtime.RequiredError(
                'makeupRequest',
                'Required parameter "makeupRequest" was null or undefined when calling apiMakeupSessionsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/makeup-sessions`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MakeupRequestToJSON(requestParameters['makeupRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfCreateLocationResponseFromJSON(jsonValue));
    }

    /**
     * Request makeup for selected day of abscense
     * Request makeup
     */
    async apiMakeupSessionsPost(requestParameters: ApiMakeupSessionsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfCreateLocationResponse> {
        const response = await this.apiMakeupSessionsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search makeup sessions by filter
     * Search makeup sessions
     */
    async apiMakeupSessionsSearchPostRaw(requestParameters: ApiMakeupSessionsSearchPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedResultOfGetMakeupResponse>> {
        if (requestParameters['makeupScrollFilterRequest'] == null) {
            throw new runtime.RequiredError(
                'makeupScrollFilterRequest',
                'Required parameter "makeupScrollFilterRequest" was null or undefined when calling apiMakeupSessionsSearchPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['lastSelectedId'] != null) {
            queryParameters['lastSelectedId'] = requestParameters['lastSelectedId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/makeup-sessions/search`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MakeupScrollFilterRequestToJSON(requestParameters['makeupScrollFilterRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResultOfGetMakeupResponseFromJSON(jsonValue));
    }

    /**
     * Search makeup sessions by filter
     * Search makeup sessions
     */
    async apiMakeupSessionsSearchPost(requestParameters: ApiMakeupSessionsSearchPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedResultOfGetMakeupResponse> {
        const response = await this.apiMakeupSessionsSearchPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
